import React, { useEffect, useState } from 'react'
import CardSlider from '../../component/Events/CardSlider';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetItems } from '../../redux/createEvent/createEventAction/GetEventAction';
import {getWishlist} from '../../redux/auth/action/fetchWishlist';

function Wishlist() {
  const allEvents = useSelector(state => state.getEvent);
  const dispatch = useDispatch();

  const wishlist = useSelector(state => state.wishlist);
  const [favEvents, setFavEvents] = useState([]);

  useEffect(() => {
    dispatch(fetchGetItems());
  }, [dispatch])

  useEffect(() => {
    dispatch(getWishlist())
  }, [dispatch])

  useEffect(() => {
    // First, check if we have wishlist items
    if (!wishlist?.wishlist?.length) {
      console.log("No wishlist items found");
      setFavEvents([]);
      return;
    }

    // Get event IDs from wishlist
    const favEventIds = wishlist.wishlist.map(item => item.event);
    console.log("Favorite event IDs:", favEventIds);
    
    // Check and log the structure of allEvents
    console.log("All events structure:", allEvents);
    
    // Carefully access the events array - try multiple possible structures
    let eventsArray = [];
    
    if (Array.isArray(allEvents.data)) {
      // If allEvents.data is already an array
      eventsArray = allEvents.data;
      console.log("Events data is an array");
    } else if (allEvents.data?.results && Array.isArray(allEvents.data.results)) {
      // If allEvents.data is a pagination object with a results array
      eventsArray = allEvents.data.results;
      console.log("Events data is a pagination object with results array");
    } else if (allEvents.data) {
      // If allEvents.data exists but isn't in expected format
      console.log("Events data exists but is not in expected format:", typeof allEvents.data);
    } else {
      // If no data yet
      console.log("No events data available yet");
    }
    
    // Now filter the events
    if (eventsArray.length > 0) {
      const filtered = eventsArray.filter(event => 
        event && event.event_id && favEventIds.includes(event.event_id)
      );
      console.log("Filtered events:", filtered);
      setFavEvents(filtered);
    } else {
      console.log("No events to filter");
      setFavEvents([]);
    }
  }, [allEvents, wishlist]);

  if (wishlist.loading || allEvents.loading) {
    return <div>Loading wishlist...</div>;
  }

  return (
    <>
      {favEvents && favEvents.length > 0 ? (
        <CardSlider data={favEvents} />
      ) : (
        <div className="text-center py-8">
          <h2 className="text-xl font-semibold">No events in your wishlist</h2>
          <p className="text-gray-500 mt-2">Add some events to your wishlist to see them here.</p>
        </div>
      )}
    </>
  )
}

export default Wishlist
